import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const painPoints = ['Cursos de software minero que cuestan $400, $600 o $800 dólares — y tu sueldo en pesos no te da ni para pensarlo.', 'Horas buscando en YouTube tutoriales de Deswik, Vulcan o Leapfrog en inglés, mal explicados, sin contexto argentino.', 'Certificaciones que se exigen en el trabajo pero que nadie te enseña dentro de la empresa — y tenés que pagártelas vos.', 'Capacitaciones de seguridad que tu empresa nunca da completas — y en la próxima auditoría quedás expuesto.', 'Manuales técnicos dispersos en 40 carpetas diferentes, en inglés, sin orden, sin aplicación práctica.'];
export function PainPointsSection() {
  return <section className="py-12 md:py-20 px-4 bg-white" data-id="element-195">
      <div className="max-w-4xl mx-auto" data-id="element-196">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-12" data-id="element-197">
          Si trabajás en minería o estudiás ingeniería minera en Argentina,{' '}
          <br className="hidden md:block" data-id="element-198" />
          <span className="text-brand-orange" data-id="element-199">
            esto te va a sonar familiar:
          </span>
        </h2>

        <div className="space-y-4 md:space-y-6 mb-8 md:mb-12 bg-red-50 p-5 md:p-8 rounded-2xl border border-red-100" data-id="element-200">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-201">
              <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-202" />
              <p className="text-xl font-medium text-gray-800" data-id="element-203">{point}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-204">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-dark mb-5 md:mb-8" data-id="element-205">
            ¿Cuánto tiempo más vas a perder buscando lo que ya existe en un solo
            lugar?
          </h3>
          <div className="max-w-xl mx-auto" data-id="element-206">
            <CTAButton text="→ QUIERO DEJAR DE BUSCAR Y EMPEZAR A AVANZAR" href="#compra" data-id="element-207" />
          </div>
        </div>
      </div>
    </section>;
}